import { Component, Input, OnInit } from '@angular/core';
import { createAvatar } from '@dicebear/core';
import { lorelei } from '@dicebear/collection';

@Component({
  selector: 'app-avatar-icon',
  templateUrl: './avatar-icon.component.html',
  styleUrls: ['./avatar-icon.component.scss'],
})
export class AvatarIconComponent implements OnInit {
  @Input() seed!: string;
  @Input() size: number = 46;
  avatarUrl: string | undefined;

  ngOnInit(): void {
    const backgroundColor = this.getPastel(this.getColor(this.seed), 4);
    const avatar = createAvatar(lorelei, {
      seed: this.seed,
      size: this.size,
      backgroundColor: [backgroundColor],
    });

    this.avatarUrl = avatar.toDataUri();
  }

  getColor(seed: string): string {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${hash % 360}, 70%, 50%)`;
  }

  getPastel(color: string, factor: number): string {
    return color.replace('70%', `${factor * 10}%`);
  }
}
